import { render, staticRenderFns } from "./concreteOrder.vue?vue&type=template&id=396a4fd2&scoped=true"
import script from "./concreteOrder.vue?vue&type=script&lang=js"
export * from "./concreteOrder.vue?vue&type=script&lang=js"
import style0 from "./concreteOrder.vue?vue&type=style&index=0&id=396a4fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a4fd2",
  null
  
)

export default component.exports